import { CSSProperties } from 'react';

export const errorTextAreaStyle: CSSProperties = {
	borderColor: 'var(--color-red)',
};
